export const SET_ANSWER = "SET_ANSWER";
export const DELETE_ANSWER = "DELETE_ANSWER";
export const GET_ANSWRES = "GET_ANSWERS";
export const SET_ANSWERS = "SET_ANSWERS";
export const SET_QUIZ_TYPES = "SET_QUIZ_TYPES";
export const SET_QUIZ_ANSWERS = "SET_QUIZ_ANSWERS";
export const SET_PROFILE = "SET_PROFILE";
